import { Button } from '@lensora/ui'
import { Check, X } from 'lucide-react'

import type { DemoResult } from '../useOnboardingMachine'
import { DEMO_INTERRUPTED_TEXT } from '../useOnboardingMachine'

import { PlatformResponseBody } from '@/components/dashboard/PlatformResponseBody'

const SENTIMENT_LABEL: Record<string, string> = {
  positive: 'Positive',
  neutral: 'Neutral',
  negative: 'Negative',
}

interface DemoResponseTurnProps {
  result?: DemoResult | undefined
  onContinue: () => void
  onRetry: () => void
}

export function DemoResponseTurn({ result, onContinue, onRetry }: DemoResponseTurnProps) {
  if (!result) {
    return (
      <div className="space-y-3">
        <p className="text-sm text-text-muted">{DEMO_INTERRUPTED_TEXT}</p>
        <Button size="sm" onClick={onRetry}>Try again</Button>
      </div>
    )
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center gap-1.5 text-sm">
        {result.brand_mentioned ? (
          <span className="flex items-center gap-1 text-feedback-success">
            <Check className="h-3.5 w-3.5" /> Mentioned
          </span>
        ) : (
          <span className="flex items-center gap-1 text-text-muted">
            <X className="h-3.5 w-3.5" /> Not mentioned
          </span>
        )}
        {result.sentiment && (
          <span className="text-xs text-text-muted">· {SENTIMENT_LABEL[result.sentiment] ?? result.sentiment}</span>
        )}
      </div>
      <PlatformResponseBody
        text={result.response_text}
        brandName={result.brand_name}
        brandMentioned={result.brand_mentioned}
      />
      <Button size="sm" onClick={onContinue}>Continue →</Button>
    </div>
  )
}
